// extracted by mini-css-extract-plugin
export default {"balances":"PackagesHistory_balances__UYZwC","balancesItem":"PackagesHistory_balancesItem__Itlnj"};